import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const benefits = ['Organizar toda la información de tus clientes de forma clara', 'Tener control sobre vencimientos fiscales importantes', 'Gestionar documentos contables sin perder tiempo buscándolos', 'Implementar checklists de trabajo para no olvidar tareas', 'Mantener un sistema de control sobre el trabajo contable', 'Reducir el estrés que generan los vencimientos y las tareas acumuladas'];
const resultItems = ['Un estudio contable más ordenado.', 'Menos tiempo buscando información.', 'Más control sobre tus clientes.', 'Más claridad en tu trabajo diario.'];
export function SolutionSection() {
  return <section className="py-12 sm:py-20 px-4 bg-[#0B1A2E] relative overflow-hidden" data-id="element-390">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 right-0 -translate-y-1/2 w-[500px] h-[500px] bg-green-500/8 rounded-full blur-[120px] pointer-events-none" data-id="element-391" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-392">
        {/* Label */}
        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-4" data-id="element-393">
          <span className="inline-block text-green-400 font-bold tracking-wider text-sm sm:text-base uppercase bg-green-900/20 px-5 py-2 rounded-full border border-green-800/40" data-id="element-394">
            La solución práctica
          </span>
        </motion.div>

        {/* Title */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-395">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 leading-tight" data-id="element-396">
            Sistema de organización para contadores independientes
          </h2>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto mb-3" data-id="element-397">
            Un sistema simple y práctico diseñado específicamente para
            contadores que trabajan con múltiples clientes.
          </p>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto" data-id="element-398">
            Este sistema te permite transformar el caos diario en un flujo de
            trabajo claro y ordenado.
          </p>
        </motion.div>

        {/* Benefits card */}
        <div className="bg-slate-800/50 border border-green-900/30 rounded-2xl p-6 md:p-10 mb-10 shadow-xl" data-id="element-399">
          <p className="text-slate-300 text-base md:text-lg mb-6 font-medium" data-id="element-400">
            Con este sistema vas a poder:
          </p>

          <div className="space-y-5" data-id="element-401">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4" data-id="element-402">
                <div className="bg-green-500/20 p-1.5 rounded-full flex-shrink-0 mt-0.5" data-id="element-403">
                  <CheckIcon className="w-5 h-5 text-green-400" data-id="element-404" />
                </div>
                <span className="text-lg text-slate-200" data-id="element-405">{benefit}</span>
              </motion.div>)}
          </div>
        </div>

        {/* Result section */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-slate-800/50 border border-green-900/30 rounded-2xl p-6 md:p-10 shadow-xl" data-id="element-406">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-407">
            <div className="h-px flex-1 bg-gradient-to-r from-transparent to-green-500/30" data-id="element-408" />
            <h3 className="text-base sm:text-lg md:text-xl font-bold text-green-400 uppercase tracking-wider text-center" data-id="element-409">
              El resultado
            </h3>
            <div className="h-px flex-1 bg-gradient-to-l from-transparent to-green-500/30" data-id="element-410" />
          </div>

          <div className="space-y-4 mb-8" data-id="element-411">
            {resultItems.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-center gap-3" data-id="element-412">
                <span className="w-1.5 h-1.5 rounded-full bg-green-400 flex-shrink-0" data-id="element-413" />
                <span className="text-base md:text-lg text-slate-200" data-id="element-414">
                  {item}
                </span>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.6
        }} className="pt-6 border-t border-slate-700 text-center" data-id="element-415">
            <p className="text-lg text-slate-300" data-id="element-416">
              Todo en un método práctico, diseñado para que puedas enfocarte en
              lo más importante:
            </p>
            <p className="text-xl text-white font-bold mt-2" data-id="element-417">
              trabajar con tus clientes y hacer crecer tu estudio contable.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}